__turbopack_context__.v({
  "circled-chevron-left-icon": "CircledChevronLeft-module-scss-module__ArM12G__circled-chevron-left-icon",
});
